/**
 * Catches a boot that dies before React renders — createEnv throwing on a
 * missing VITE_PUBLIC_*, a dependency failing at import time. Must be the first
 * import in main.tsx, ahead of every module that reads env.
 *
 * The splash from index.html covers #root, so a dead boot looks like a running
 * one. The guard drops the splash and prints the reason instead.
 */

// Polyfill: Object.hasOwn (Chrome 93+), missing in Android WebView 90/91 while
// bundled deps call it at startup. The method reference is captured up front —
// an inline Object.prototype.hasOwnProperty.call is auto-rewritten to
// Object.hasOwn and would make the polyfill recurse.
const objectConstructor = Object as { hasOwn?: unknown }
if (typeof objectConstructor.hasOwn !== "function") {
	const hasOwnProp = Object.prototype.hasOwnProperty
	Object.defineProperty(Object, "hasOwn", {
		value: (target: object, key: PropertyKey): boolean =>
			hasOwnProp.call(target, key),
		configurable: true,
		writable: true,
	})
}

let armed = true

export function disarmGuard(): void {
	armed = false
}

function renderBootFailure(detail: string): void {
	if (!armed) return

	const root = document.getElementById("root")
	if (!root || root.childElementCount > 0) return

	document.getElementById("splash")?.remove()

	const box = document.createElement("div")
	box.style.cssText =
		"position:fixed;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;padding:24px;text-align:center;font-family:sans-serif;color:#fff;background:#000"

	const title = document.createElement("div")
	title.style.cssText = "font-size:17px;font-weight:600"
	title.textContent = "Не удалось запустить приложение"

	const hint = document.createElement("div")
	hint.style.cssText =
		"font-size:13px;opacity:.6;max-width:320px;word-break:break-word"
	hint.textContent = detail

	box.append(title, hint)
	root.append(box)
}

window.addEventListener("error", (event) => {
	renderBootFailure(event.message || String(event.error))
})
window.addEventListener("unhandledrejection", (event) => {
	renderBootFailure(String(event.reason))
})
